import React, { Fragment } from 'react';
import * as Yup from 'yup';

import { Formik } from 'formik';
import moment from 'moment';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import Calendar from './Calendar';

import {
    makeStyles,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Card,
    CardHeader,
    CardContent,
    Avatar
} from '@material-ui/core';

import { RiCalendarLine } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
    container: {
        maxHeight: 530,
        minHeight: 530
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.cyan[500]
    }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Schedule = ({ item, open, closeEdition, updateValues, changeDatetime, changeSchedule, appointments, selectedMode }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Agendamento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Box mt={1}>

                                    <Grid
                                        container
                                        spacing={2}
                                        xs="auto"
                                    >

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none" >
                                                <InputLabel shrink htmlFor="prestadora" required={true} >Departamento</InputLabel>
                                                <Select
                                                    notched
                                                    autosize
                                                    required
                                                    error={Boolean(touched.prestadora && errors.prestadora)}
                                                    value={values.prestadora}
                                                    onChange={e => {
                                                        changeSchedule(e, values);
                                                        handleChange(e);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="Departamento"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'prestadora',
                                                        id: 'prestadora',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {appointments.typesTechnician.map((typeTechnician) => (
                                                        <MenuItem key={typeTechnician.id} value={typeTechnician.id}>{typeTechnician.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={3}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="tecnico" required={true} >Técnico</InputLabel>
                                                <Select
                                                    notched
                                                    required
                                                    autosize
                                                    error={Boolean(touched.tecnico && errors.tecnico)}
                                                    value={values.tecnico}
                                                    onChange={e => {
                                                        changeSchedule(e, values);
                                                        handleChange(e);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="Técnico"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'tecnico',
                                                        id: 'tecnico',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {appointments.technicians.map((technician) => (
                                                        <MenuItem key={technician.id} value={technician.id}>{technician.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>
                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="auxiliar" required={true} >Auxiliar</InputLabel>
                                                <Select
                                                    notched
                                                    required
                                                    autosize
                                                    error={Boolean(touched.auxiliar && errors.auxiliar)}
                                                    value={values.auxiliar}
                                                    onChange={e => {
                                                        handleChange(e);
                                                    }}
                                                    onBlur={handleBlur}
                                                    label="Auxiliar"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'auxiliar',
                                                        id: 'auxiliar',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {appointments.technicians.map((technician) => (
                                                        <MenuItem key={technician.id} value={technician.id}>{technician.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                cancelLabel="Cancelar"
                                                error={Boolean(touched.dataAgenda && errors.dataAgenda)}
                                                margin="none"
                                                required
                                                inputVariant="outlined"
                                                id="dataAgenda"
                                                label="Data"
                                                format="DD/MM/YYYY"
                                                name="dataAgenda"
                                                minDateMessage={'Data não pode ser menor que a data de abertura da ocorrência'}
                                                maxDateMessage={'Data não pode ser maior que 30 dias após a data limite conclusão CPC'}
                                                minDate={values.abertura}
                                                maxDate={moment(values.dateConclusion).add(30, 'day')}
                                                value={values.dataAgenda}
                                                onBlur={handleBlur}
                                                onChange={value => {
                                                    changeDatetime(value, values);
                                                    setFieldValue("dataAgenda", value);
                                                }}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={1}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.hora && errors.hora)}
                                                fullWidth
                                                label="Hora"
                                                type="time"
                                                margin="none"
                                                id="hora"
                                                name="hora"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.hora}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: false, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="veiculo" required={false} >Veículo</InputLabel>
                                                <Select
                                                    notched
                                                    autosize
                                                    error={Boolean(touched.veiculo && errors.veiculo)}
                                                    value={values.veiculo}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Veículo"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'veiculo',
                                                        id: 'veiculo',
                                                    }}
                                                >
                                                    <MenuItem value={null}>
                                                        <em>Selecione uma das opções abaixo</em>
                                                    </MenuItem>
                                                    {appointments.veicles.map((veicle) => (
                                                        <MenuItem key={veicle.id} value={veicle.id}>{veicle.id} - {(veicle.nome) ? (veicle.nome) : ""}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.observacao && errors.observacao)}
                                                fullWidth
                                                label="Observações"
                                                rows={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? 3 : 1}
                                                multiline={(screen.width <= 480 || selectedMode == MODE_COMPACT) ? true : false}
                                                margin="none"
                                                name="observacao"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.observacao}
                                                variant="outlined"
                                                inputProps={{ maxLength: 150 }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>


                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <Card variant="outlined" divider className={classes.container}>

                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <RiCalendarLine />
                                                        </Avatar>
                                                    }
                                                    title={
                                                        <Fragment>
                                                            <Typography
                                                                component="span"
                                                                variant="h5"
                                                                color="textPrimary">
                                                                {(appointments.schedules.length == 1) ? ('1 Agendamento Encontrado') : (appointments.schedules.length + ' Agendamentos Encontrados')}
                                                            </Typography>
                                                        </Fragment>
                                                    }
                                                />

                                                <Divider />
                                                <CardContent>

                                                    <Calendar
                                                        date={values.abertura}
                                                        appointments={appointments.schedules}
                                                        size={750}
                                                        interval={3}
                                                    />

                                                </CardContent>
                                            </Card>
                                        </Grid>

                                    </Grid>

                                </Box>

                                <br></br>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Schedule;
